module.exports = __webpack_public_path__ + "static/media/ccc.f5e6b371.jpg";